import { render } from "./Documents.vue?vue&type=template&id=0b2f81b1"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"
script.render = render

export default script